import { Ref, ref, watch } from 'vue';

export type ActiveTableSidebarItem = {
  id: number;
  key: string;
  label: string;
};

export const useActiveTableSidebar = (items: Ref<ActiveTableSidebarItem[]>) => {
  const currentActiveTableSidebarItem = ref<string>(items.value[0]?.key);
  const updateCurrentActiveTableSidebarItem = (itemKey: string) => {
    currentActiveTableSidebarItem.value = itemKey;
  };

  watch(items, () => {
    currentActiveTableSidebarItem.value = items.value[0]?.key;
  });

  return {
    activeTableSidebarItems: items,
    currentActiveTableSidebarItem,
    updateCurrentActiveTableSidebarItem,
  };
};
